import React from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { LazyLoadImages } from "@quintype/components";

import Row1 from "./Row1";
import Row2 from "./Row2";
import Column from "./Column";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fourteenStories2Ad1Widget.m.css";

const FourteenStories2Ads1Widget = ({ collection, sections, lang, liveBlogStory, domainSlug }) => {
  const stories = collection.items.length > 0 ? collection.items.filter((item) => item.type === "story") : [];

  if (!stories.length) {
    return null;
  }

  const row1Stories = stories.slice(0, 2);
  const columnStories = stories.slice(11, 15);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);

  const getRow2 = () => (
    <Row2 stories={stories.slice(1, 14)} publisherLang={lang} liveBlogStory={liveBlogStory} adSlotId={adSlotId1} />
  );

  const getColumn = () => (
    <Column stories={columnStories} collectionSlug={collectionSlug} publisherAttributes={lang} adSlotId={adSlotId2} />
  );

  return stories.length > 1 ? (
    <div styleName="base" className="fourteen-stories-3ad-1widget">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} />
      )}
      <div styleName="wrapper">
        <div>
          {row1Stories.length > 0 && (
            <Row1
              stories={row1Stories}
              widgetUrl={widgetUrl}
              collectionSlug={collectionSlug}
              publisherAttributes={lang}
              liveBlogStory={liveBlogStory}
              adSlotId={adSlotId2}
            />
          )}
          <LazyLoadImages margin="20px">{getRow2()}</LazyLoadImages>
        </div>
        <LazyLoadImages margin="20px">{getColumn()}</LazyLoadImages>
      </div>
      <div styleName="ad-slot">
        <DfpAd
          adtype={lang === "en" ? "EnPalo_HP_468x60_B1" : "Home_468x60_B1"}
          collectionSlug={collectionSlug}
          layoutName="FourteenStories3Ad1Widget"
          slotId={adSlotId3}
        />
      </div>
    </div>
  ) : null;
};

FourteenStories2Ads1Widget.propTypes = {
  collection: object.isRequired,
  sections: array,
  lang: string,
  liveBlogStory: object,
  domainSlug: string,
};

FourteenStories2Ads1Widget.storyLimit = 13;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FourteenStories2Ads1Widget);
